import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './views/login/login.component';
import { RecuperarClaveComponent } from './views/recuperar-clave/recuperar-clave.component';
import { CambiarClaveComponent } from './views/cambiar-clave/cambiar-clave.component';


const adminSeguridadRoutes: Routes = [
  { path: 'login', component: LoginComponent},
  { path: 'recuperar-clave', component: RecuperarClaveComponent},
  { path: 'login/RegistroClienteServlet/:hash/:categoria', component: CambiarClaveComponent},
];

@NgModule({
  imports: [RouterModule.forChild(adminSeguridadRoutes)],
  exports: [RouterModule]
})
export class SeguridadRoutingModule {}
